<template lang="pug">
  .Framework(:class="backgroundClass")
    h1(:class="titleAnimation") 实现架构
    viewer.viewer(:class="contentAnimation" :images="[framework]")
      img(:src="framework")
</template>

<script>
  import Mixin from "../../index.js";
  export default {
    name: "Framework",
    mixins: [Mixin],
    props: {framework: {type: String}, backgroundClass: String},
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .Framework {
    VStack(center, center)
    padding 100px 0
    background #f8f8f8
    border-top 1px solid #e4e4e4
    border-bottom 1px solid #e4e4e4
  }
  .marketBackground {
    background transparent
    border-top 0
    border-bottom 0
  }
  .viewer {
    VStack(center)
  }
  img {
    max-width 90%
    width 1000px
  }
  @media (max-width screenWidth) {
    .Framework {
      padding 50px 0
    }
    img {
      width 100%
    }
  }
</style>
